import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Router} from "@angular/router";
import {GlobalService} from "../../../global.service";
import {Service} from "../../../services";
import {LoadingScreenService} from "../../../services/loading-screen/loading-screen.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-recharge-response',
  templateUrl: './recharge-response.component.html',
  styleUrls: ['./recharge-response.component.sass']
})
export class RechargeResponseComponent implements OnInit, OnChanges {
  @Input() valueRecharged;
  @Input() validatePaymentSuccess: boolean;
  date: any;
  @Input() phoneNumber;
  @Output() updateScreenView = new EventEmitter();
  @Output() updateinitializeData = new EventEmitter()
  @Output() updateNroOrder = new EventEmitter<boolean>()
  @Input() accounInfo;
  @Input() id;
  @Input() token;
  @Input() actualType;
  @Input() currentSoc;
  @Input() nextSoc;
  @Input() condition;
  returnHome: Subscription;
  nextViewActivated: boolean;
  interval: any;
  continueSelected = false;
  timer = 25;
  paymentToken: string;
  validateVoidPayment: Subscription;
  refundView: boolean;

  constructor(
    private router: Router,
    private global: GlobalService,
    private services: Service,
    private loadingScreenService: LoadingScreenService,
  ) {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.validatePaymentSuccess !== undefined) {
      if (changes.validatePaymentSuccess.currentValue === true) {
        if (this.condition) {
          this.automaticContinue()
          this.newDate()
        }
      }
    }
  }

  ngOnInit() {
    this.paymentToken = sessionStorage.getItem('paymentToken')
  }

  newDate() {
    const d = new Date();
    return this.date = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
  }


  return() {
    this.router.navigate(['home'])
  }

  continue() {
    this.continueSelected = true;
    this.updateView();
  }

  updateView() {
    this.updateScreenView.emit(3);
    this.updateNroOrder.emit(false);
  }


  automaticContinue() {
    if (!this.continueSelected) {
      setTimeout(() => {
        this.timer = this.timer - 1;
        if (this.timer === 0) {
          this.updateView();
         // this.continue();
        } else {
          this.automaticContinue();
        }
      }, 1000)
    } else {
      return
    }
  }
}
